module.exports = __webpack_public_path__ + "media/img/pages/companies/post-1b93ea7650e256086fb4279dc96ac7c1.png";